import * as React from "react";
import {
    Box,
    Paper,
    Popover,
    Button,
    Grid,
    Backdrop,
    TableContainer,
    Table,
    TableCell,
    TableBody,
    TableRow,
    TableHead,
    List,
    ListItemButton,
    Collapse,
    Typography,
    Stack,
    FormControlLabel,
    Checkbox,
} from "@mui/material";
import { styled, alpha, useTheme } from "@mui/material/styles";
import Menu, { MenuProps } from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useState, useEffect, useContext } from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { PAGE_SIZE } from "../../Services/common/const";
import Title from "../../Components/Title";
import ShortcutButton from "../../Components/ShortcutButton";
import { PreferencesContext } from "../../PreferencesContext";
import { AlertType } from "../../shared/Modal/AlertType";
import MissingConsumer from "../../Components/MissingConsumer";
import DownloadIcon from "@mui/icons-material/Download";
import { format } from "date-fns";
import {
    ExportFilesFunction,
    numberFormat,
} from "../../shared/CommonFuctions";
import SplashComponent from "../../Navigation/splash";
import {
    ExpandLess,
    ExpandMore,
    KeyboardArrowDownSharp,
} from "@mui/icons-material";
import { GetProductList } from "../../Services/CategoryProductService";
import MultiSelect from "../../Components/MultiSelect";
import PaginationAdvance from "../../Components/PaginationAdvance";
import { EncryptDecryptService } from "../../Services/common/EncryptionService";
import { useLocation, useNavigate } from "react-router-dom";
import CustomDateRangePicker from "../../Components/CustomDateRange";
import { LoadingButton } from "@mui/lab";
import { GetStockLedgerReport } from "../../Services/ReportService";
import { GetStockLedgerList } from "../../Services/StockService";

interface IProduct {
    productId: number;
    name: string;
    label: string;
    value: string;
}

export default function StockLedgerReport() {
    const matches = useMediaQuery("(max-width:599px)");
    const tabMatches = useMediaQuery("(max-width:768px)");
    const edService = new EncryptDecryptService();
    const navigate = useNavigate();
    const location = useLocation();
    const theme = useTheme();
    const mobileScreen = useMediaQuery(theme.breakpoints.down("sm"));

    function useQuery() {
        const { search } = useLocation();
        return React.useMemo(() => new URLSearchParams(search), [search]);
    }

    let urlParams = useQuery();

    const state = location.state as any;
    const productIdFromState = state?.productId || 0;
    const productIdsFromState = state?.productIds || [];
    const startDateFromState = state?.startDate || '';
    const endDateFromState = state?.endDate || '';
    const particularsFromState = state?.particulars || '';
    const productNameFromState = state?.productName || '';
    const fromSummary = state?.fromSummary || false;

    const productIds = productIdsFromState.length > 0 
        ? productIdsFromState 
        : (productIdFromState ? [productIdFromState] : []);
    
    const productId = productIds.length > 0 ? productIds[0] : 0;
    const isFromSummaryPage = productId > 0;

    console.log('productIdFromState:', productIdFromState);
    console.log('productIdsFromState:', productIdsFromState);
    console.log('Final productIds:', productIds);
    console.log('Final ProductId:', productId);
    console.log('Start Date from state:', startDateFromState);
    console.log('End Date from state:', endDateFromState);

    const productIdFromPlainUrl = Number(urlParams.get("productId")) || 0;
    const startDateFromPlainUrl = urlParams.get("startDate") || '';
    const endDateFromPlainUrl = urlParams.get("endDate") || '';
    const particularsFromPlainUrl = urlParams.get("particulars") || '';
    const productNameFromPlainUrl = urlParams.get("productName") || '';

    let enledgerAccountId: any = urlParams.get("q");
    let enLedgerAccountDetailId = urlParams.get("d");
    let decLedgerAccountDetailId: any = edService.decrypt(enLedgerAccountDetailId);
    let decledgerAccountId: any = edService.decrypt(enledgerAccountId);
    const productIdFromEncryptedUrl = decledgerAccountId ? parseInt(decledgerAccountId) : 0;

    const finalProductId = productId || productIdFromPlainUrl || productIdFromEncryptedUrl || 0;
    const startDateFromNav = startDateFromState || startDateFromPlainUrl;
    const endDateFromNav = endDateFromState || endDateFromPlainUrl;
    const particularsFromNav = particularsFromState || particularsFromPlainUrl;
    const productNameFromNav = productNameFromState || productNameFromPlainUrl;

    const isFromSummaryPageFinal = finalProductId > 0;

    console.log('finalProductId:', finalProductId);
    console.log('Product Name from Nav:', productNameFromNav);
    console.log('Final Start Date:', startDateFromNav);
    console.log('Final End Date:', endDateFromNav);

    const [page_Index, setPage_Index] = useState(1);
    const [page_Size, setPage_Size] = useState<any>(10);
    const [counData, setCounData] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [pageStartIndex, setPageStartIndex] = useState(1);
    const [pageEndIndex, setPageEndIndex] = useState(1);
    const [sourceProductCollection, setSourceProductCollection] = React.useState<IProduct[]>([]);
    const { userContext, updateUserContext } = useContext(PreferencesContext);
    const [isLoading, setLoading] = React.useState(false);
    const [selectedDateRange, setDateRange] = useState([
        {
            startDate: new Date(userContext.financialYearStartDate),
            endDate: new Date(),
            key: "selection",
        },
    ]);
    const [openProduct, setOpenProduct] = React.useState<any[]>([]);
    const [selectedProductIds, setSelectedProductIds] = React.useState<any[]>([]);
    const [selectedProductIdData, setSelectedProductIdData] = React.useState<any[]>([]);
    const [isCollapsed, setIsCollapsed] = React.useState<any>(true);
    const [anchorEl2, setAnchorEl2] = React.useState<null | HTMLElement>(null);
    const openExportType = Boolean(anchorEl2);
    const [Curr_page, setCurrPage] = useState(1);
    const [resultData, setResultData] = useState<any>({
        stockLedgerListCollection: [],
        stockLedgerDetailCollection: [],
    });
    
    const [fromDate, setFromDate] = React.useState<any>(() => {
        if (startDateFromNav && endDateFromNav) {
            console.log('Setting initial fromDate from nav:', startDateFromNav);
            return new Date(startDateFromNav);
        }
        return userContext.financialYearStartDate;
    });
    
    const [toDate, setToDate] = React.useState<any>(() => {
        if (startDateFromNav && endDateFromNav) {
            console.log('Setting initial toDate from nav:', endDateFromNav);
            return new Date(endDateFromNav);
        }
        return userContext.financialYearEndDate;
    });

    const handleClickExportType = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl2(event.currentTarget);
    };

    const handleCloseExportType = () => {
        setAnchorEl2(null);
    };

    const handleChange = (object: any) => {
        console.log("Dropdown changed, selected:", object);
        setSelectedProductIds(object);
        let tempProductIdData: any[] = [];
        object.forEach((x: any) => {
            if (x?.value === "*") {
                return;
            } else {
                tempProductIdData.push(x.productId.toString());
            }
        });
        console.log("Product IDs from dropdown:", tempProductIdData);
        setSelectedProductIdData(tempProductIdData);
    };

    const handleChangePageNew = (
        event: React.MouseEvent<HTMLButtonElement> | null,
        value: number
    ) => {
        if (Curr_page !== value) {
            setCurrPage(value);
            setPage_Index(value);
            fetchStockLedgerReportList();
        }
    };

    type PageSizeChangeEvent = {
        value: string;
        label: string;
    };

    const handlePageSizeCahange = (event: PageSizeChangeEvent) => {
        if (event !== null) {
            setPage_Size(parseInt(event.value));
            setPage_Index(1);
            setCurrPage(1);
        }
    };

    const StyledMenu = styled((props: MenuProps) => (
        <Menu
            elevation={0}
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            transformOrigin={{ vertical: "top", horizontal: "right" }}
            {...props}
        />
    ))(({ theme }) => ({
        "& .MuiPaper-root": {
            borderRadius: 6,
            marginTop: theme.spacing(1),
            minWidth: 50,
            color:
                theme.palette.mode === "light"
                    ? "rgb(55, 65, 81)"
                    : theme.palette.grey[300],
            boxShadow:
                "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
            "& .MuiMenu-list": { padding: "4px 0" },
            "& .MuiMenuItem-root": {
                "& .MuiSvgIcon-root": {
                    fontSize: 18,
                    color: theme.palette.text.secondary,
                    marginRight: theme.spacing(1.5),
                },
                "&:active": {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        theme.palette.action.selectedOpacity
                    ),
                },
            },
        },
    }));

    async function getProducts(onInit: any, searchValue: any) {
        let params = new URLSearchParams();
        let productCollectionData: any;
        params.append("consumerId", userContext.consumerId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("pageIndex", "1");
        params.append("pageSize", "1000");
        params.append("sortColumn", "name");
        params.append("sortDirection", "ASC");
        params.append("searchValue", searchValue || "");
        params.append("mode", "");
        params.append("financialYear", userContext.financialYear?.toString());
        try {
            const result: any = await GetProductList(params);
            if (result) {
                productCollectionData = result?.data?.data?.productCollection;
                if (productCollectionData) {
                    const formattedData = productCollectionData.map((item: any) => ({
                        ...item,
                        label: item.name,
                        value: item.productId.toString(),
                    }));
                    setSourceProductCollection(formattedData);
                }
            }
        } catch (error) {
            console.log(error);
        }
        return productCollectionData;
    }

    async function openStockLedgerExportPopup(type: any) {
        setAnchorEl2(null);
        setLoading(true);
        var attachmentName = "";
        if (type === "pdf") {
            attachmentName = "StockLedgerReport_" + format(new Date(), "yyyyMMdd") + ".pdf";
        } else {
            attachmentName = "StockLedgerReport_" + format(new Date(), "yyyyMMdd") + ".xls";
        }
        let params = new URLSearchParams();
        params.append("reportName", "StockLedgerReport");
        params.append("reportType", type);
        params.append("consumerId", userContext.consumerId.toString());
        params.append("branchId", userContext.branchId.toString());
        params.append("firmId", userContext.firmId.toString());
        params.append("productIds", selectedProductIdData.join(','));
        params.append("pageSize", page_Size.toString());
        params.append("pageIndex", page_Index.toString());
        params.append("financialYear", userContext.financialYear.toString());
        params.append("startDate", format(new Date(fromDate), "yyyy-MM-dd"));
        params.append("endDate", format(new Date(toDate), "yyyy-MM-dd"));
        params.append("fileName", attachmentName);
        params.append("mode", "Export");
        params.append("isForDownload", '1');
        try {
            const result: any = await GetStockLedgerReport(params);
            if (result && result.data && result.data.data) {
                var fileContent = result?.data?.data?.fileData;
                var attachmentData = fileContent;
                ExportFilesFunction(attachmentName, type, attachmentData);
                setLoading(false);
            }
            setLoading(false);
        } catch (e: any) {
            setLoading(false);
            updateUserContext({
                ...userContext,
                isAlert: true,
                alertMessage: e?.message || "Export failed",
                alertType: AlertType.Error,
            });
        }
    }

    const fetchStockLedgerReportList = async () => {
        let productIdList = [];
        
        if (selectedProductIdData && selectedProductIdData.length > 0) {
            productIdList = selectedProductIdData;
            console.log("Using dropdown selection:", productIdList);
        }

        else if (isFromSummaryPageFinal) {
            productIdList = productIds.length > 0 
                ? productIds.map((id: any) => id.toString())
                : [finalProductId.toString()];
            console.log("Using summary state:", productIdList);
        }

        else if (finalProductId > 0) {
            productIdList = [finalProductId.toString()];
            console.log("Using URL fallback:", productIdList);
        }

        if (!productIdList || productIdList.length === 0) {
            console.log("No products selected");
            setResultData({
                stockLedgerListCollection: [],
                stockLedgerDetailCollection: [],
            });
            setTotalCount(0);
            setCounData(0);
            return;
        }

        setLoading(true);

        try {
            let params = new URLSearchParams();
            params.append("consumer_id", userContext.consumerId.toString());
            params.append("firm_id", userContext.firmId.toString());
            params.append("branch_id", userContext.branchId.toString());
            params.append("pageIndex", "1");
            params.append("pageSize", "9999");
            params.append("financialYear", userContext.financialYear.toString());
            params.append("product_ids", productIdList.join(','));
            params.append("batch_number", "");
            params.append("searchValue", "");
            
            if (fromDate) {
                params.append("start_date", format(new Date(fromDate), "yyyy-MM-dd"));
            }
            if (toDate) {
                params.append("end_date", format(new Date(toDate), "yyyy-MM-dd"));
            }
            
            console.log("API PARAMS:", params.toString());
            
            const result = await GetStockLedgerList(params.toString());
            
            console.log("Full API Response:", result);
            
            let allStockData = [];
            
            if (result?.data?.data?.StockLedgerReportCollection) {
                allStockData = result.data.data.StockLedgerReportCollection;
            } else if (result?.data?.StockLedgerReportCollection) {
                allStockData = result.data.StockLedgerReportCollection;
            } else if (result?.StockLedgerReportCollection) {
                allStockData = result.StockLedgerReportCollection;
            } else if (result?.data?.data?.stockLedgerReportCollection) {
                allStockData = result.data.data.stockLedgerReportCollection;
            } else if (result?.data?.stockLedgerReportCollection) {
                allStockData = result.data.stockLedgerReportCollection;
            } else if (result?.stockLedgerReportCollection) {
                allStockData = result.stockLedgerReportCollection;
            }
            
            console.log("Total records from API:", allStockData.length);
            
            if (allStockData.length === 0) {
                console.log("No data found for the selected date range");
                setResultData({
                    stockLedgerListCollection: [],
                    stockLedgerDetailCollection: [],
                });
                setTotalCount(0);
                setCounData(0);
                setLoading(false);
                return;
            }
            
            const selectedIds = productIdList.map((id: any) => Number(id));
            
            let filteredData = allStockData.filter((item: any) => {
                const productId = item.ProductId || item.productId || item.product_id || 0;
                const voucherDate = item.VoucherDate || item.voucherDate || item.voucher_date;
                
                if (!selectedIds.includes(Number(productId))) {
                    return false;
                }
                
                if (fromDate && toDate && voucherDate) {
                    const date = new Date(voucherDate);
                    const from = new Date(fromDate);
                    const to = new Date(toDate);

                    from.setHours(0, 0, 0, 0);
                    to.setHours(23, 59, 59, 999);
                    if (date < from || date > to) {
                        return false;
                    }
                }
                
                return true;
            });
            
            console.log(`Filtered to selected products and date range: ${filteredData.length} records`);
            
            if (filteredData.length === 0) {
                console.log("No data found for selected products in this date range");
                setResultData({
                    stockLedgerListCollection: [],
                    stockLedgerDetailCollection: [],
                });
                setTotalCount(0);
                setCounData(0);
                setLoading(false);
                return;
            }
            
            const productMap = new Map();
            filteredData.forEach((item: any) => {
                const productId = item.ProductId || item.productId || item.product_id || 0;
                const productName = item.ProductName || item.productName || item.product_name || 'Unknown';
                
                if (productId === 0) return;
                
                if (!productMap.has(productId)) {
                    productMap.set(productId, {
                        productId: productId,
                        productName: productName,
                        details: []
                    });
                }
                
                productMap.get(productId).details.push({
                    srNo: item.SrNo || item.srNo || 0,
                    voucherNo: item.VoucherNo || item.voucherNo || item.voucher_no || '-',
                    voucherType: item.VoucherType || item.voucherType || item.voucher_type || '-',
                    sourceType: item.SourceType || item.sourceType || item.source_type || '-',
                    availableQuantity: item.AvailableQuantity || item.availableQuantity || item.available_quantity || 0,
                    inwardQty: item.InwardQty || item.inwardQty || item.inward_qty || 0,
                    outwardQty: item.OutwardQty || item.outwardQty || item.outward_qty || 0,
                    closingBalance: item.ClosingBalance || item.closingBalance || item.closing_balance || 0,
                    stockValue: item.PurchaseAmount || item.purchaseAmount || item.purchase_amount || 0,
                    voucherDate: item.VoucherDate || item.voucherDate || item.voucher_date,
                    nature: item.Nature || item.nature || '',
                });
            });
            
            let allProductList = [];
            
            // Get selected products from sourceProductCollection
            const selectedProducts = sourceProductCollection.filter(
                (p) => selectedIds.includes(Number(p.productId))
            );
            
            selectedProducts.forEach((product) => {
                const productId = Number(product.productId);
                const existingData = productMap.get(productId);
                
                if (existingData) {
                    allProductList.push(existingData);
                } else {
                    allProductList.push({
                        productId: productId,
                        productName: product.name || 'Unknown',
                        details: []
                    });
                }
            });
            
            console.log(`Selected products: ${allProductList.length}, Products with data: ${productMap.size}`);
            
            const allDetailList = filteredData.map((item: any) => ({
                productId: item.ProductId || item.productId || item.product_id || 0,
                srNo: item.SrNo || item.srNo || 0,
                voucherNo: item.VoucherNo || item.voucherNo || item.voucher_no || '-',
                voucherType: item.VoucherType || item.voucherType || item.voucher_type || '-',
                sourceType: item.SourceType || item.sourceType || item.source_type || '-',
                availableQuantity: item.AvailableQuantity || item.availableQuantity || item.available_quantity || 0,
                inwardQty: item.InwardQty || item.inwardQty || item.inward_qty || 0,
                outwardQty: item.OutwardQty || item.outwardQty || item.outward_qty || 0,
                closingBalance: item.ClosingBalance || item.closingBalance || item.closing_balance || 0,
                stockValue: item.PurchaseAmount || item.purchaseAmount || item.purchase_amount || 0,
                voucherDate: item.VoucherDate || item.voucherDate || item.voucher_date,
            }));
            
            const totalDataCount = allProductList.length;
            setTotalCount(totalDataCount);
            
            const startIndex = (page_Index - 1) * page_Size;
            const endIndex = Math.min(startIndex + page_Size, totalDataCount);
            
            const paginatedProductList = allProductList.slice(startIndex, endIndex);
            const paginatedProductIds = paginatedProductList.map((p: any) => p.productId);
            const paginatedDetailList = allDetailList.filter((item: any) => 
                paginatedProductIds.includes(item.productId)
            );
            
            console.log("Total Selected Products:", totalDataCount);
            console.log("Products with data:", productMap.size);
            console.log("Products without data:", totalDataCount - productMap.size);
            console.log("Paginated Products:", paginatedProductList.length);
            
            setResultData({
                stockLedgerListCollection: paginatedProductList,
                stockLedgerDetailCollection: paginatedDetailList,
            });
            
            setCounData(Math.ceil(totalDataCount / page_Size));
            setPageStartIndex(startIndex + 1);
            setPageEndIndex(endIndex);
            
            setLoading(false);
        } catch (error: any) {
            setLoading(false);
            console.error("Error:", error);
            updateUserContext({
                ...userContext,
                isAlert: true,
                alertMessage: error?.message || 'Failed to fetch data',
                alertType: AlertType.Error,
            });
        }
    };

    useEffect(() => {
        getProducts(true, "");
    }, []);

    useEffect(() => {
        if (isFromSummaryPageFinal && sourceProductCollection.length > 0) {
            console.log('Auto-selecting product from state:', finalProductId);
            
            const product = sourceProductCollection.find(
                (p) => Number(p.productId) === Number(finalProductId)
            );
            
            if (product) {
                setSelectedProductIds([product]);
                setSelectedProductIdData([finalProductId.toString()]);
                
                if (startDateFromNav && endDateFromNav) {
                    console.log('Setting dates from navigation:', startDateFromNav, endDateFromNav);
                    setFromDate(new Date(startDateFromNav));
                    setToDate(new Date(endDateFromNav));
                }

                setTimeout(() => {
                    fetchStockLedgerReportList();
                }, 100);
            } else {
                console.warn('Product not found in list, fetching...');
                getProducts(true, "").then(() => {
                    const found = sourceProductCollection.find(
                        (p) => Number(p.productId) === Number(finalProductId)
                    );
                    if (found) {
                        setSelectedProductIds([found]);
                        setSelectedProductIdData([finalProductId.toString()]);
                        
                        if (startDateFromNav && endDateFromNav) {
                            setFromDate(new Date(startDateFromNav));
                            setToDate(new Date(endDateFromNav));
                        }
                        
                        setTimeout(() => {
                            fetchStockLedgerReportList();
                        }, 100);
                    }
                });
            }
        }
    }, [isFromSummaryPageFinal, sourceProductCollection]);

    useEffect(() => {
        if (selectedProductIds?.length > 0 || isFromSummaryPageFinal) {
            fetchStockLedgerReportList();
        }
    }, [fromDate, toDate, selectedProductIdData, page_Size, page_Index]);

    const handleBack = () => {
        navigate(-1);
    };

    const handleClickProduct = (productId: any) => {
        if (openProduct?.includes(productId)) {
            setOpenProduct(openProduct?.filter((item: any) => item !== productId));
        } else {
            setOpenProduct([...openProduct, productId]);
        }
    };

    const isProductSelected = selectedProductIds?.length > 0 || isFromSummaryPageFinal;

    return (
        <>
            <Backdrop
                sx={{
                    color: "#fff",
                    backgroundColor: "#fff",
                    zIndex: (theme) => theme.zIndex.drawer + 1,
                }}
                open={isLoading}
            >
                <SplashComponent />
            </Backdrop>
            <Title pageTitle="Stock Ledger Report" />
            <Box
                className="boxContainer"
                sx={{ "& > :not(style)": { width: "100%" } }}
            >
                {userContext.consumerId > 0 ? (
                    <Grid>
                        <Grid item>
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                lg={6}
                                md={6}
                                xl={6}
                                className="title-button-responsive"
                                sx={{
                                    display: "flex !important",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                }}
                            >
                                <h4 className="page-title">Stock Ledger Report</h4>
                                <LoadingButton
                                    variant="outlined"
                                    onClick={handleBack}
                                    sx={{ mb: 1 }}
                                >
                                    <ShortcutButton label="ESC" />
                                    Back
                                </LoadingButton>
                            </Grid>
                        </Grid>

                        <Grid className="paper top-space" sx={{ marginTop: "10px" }}>
                            <Paper elevation={4} className="paper-container">
                                <Grid container spacing={0.5} className="search-space">
                                    
                                    <Grid
                                        item
                                        marginTop={matches ? 1 : 0}
                                        xs={12}
                                        sm={12}
                                        md={4}
                                        lg={4}
                                        xl={4}
                                    >
                                        <MultiSelect
                                            placeholderLabel="Products"
                                            options={sourceProductCollection}
                                            onChange={handleChange}
                                            value={selectedProductIds}
                                            isSelectAll={true}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                                        <Grid
                                            sx={{
                                                display: "flex",
                                                justifyContent: { xs: "stretch", md: "flex-end" },
                                                alignItems: {
                                                    xs: "stretch",
                                                    md: "flex-start",
                                                    lg: "center",
                                                },
                                                gap: "5px",
                                                flexWrap: "wrap",
                                                "& > div, & > button, & > Box": {
                                                    width: { xs: "100%", md: "auto" },
                                                },
                                            }}
                                        >
                                            <Button
                                                className="button-responsive"
                                                variant="outlined"
                                                disabled={!isProductSelected || sourceProductCollection.length === 0}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (isCollapsed) {
                                                        setOpenProduct(
                                                            resultData?.stockLedgerListCollection?.map(
                                                                (item: any) => item?.productId
                                                            )
                                                        );
                                                    } else {
                                                        setOpenProduct([]);
                                                    }
                                                    setIsCollapsed(!isCollapsed);
                                                }}
                                            >
                                                {isCollapsed ? "Expand" : "Collapse"}
                                            </Button>

                                            <CustomDateRangePicker
                                                fromDate={fromDate}
                                                setFromDate={setFromDate}
                                                toDate={toDate}
                                                setToDate={setToDate}
                                                disabled={!isProductSelected || sourceProductCollection.length === 0}
                                            />

                                            <Button
                                                className="button-responsive"
                                                aria-controls={
                                                    openExportType ? "demo-customized-menu" : undefined
                                                }
                                                aria-haspopup="true"
                                                aria-expanded={openExportType ? "true" : undefined}
                                                variant="outlined"
                                                disableElevation
                                                disabled={!isProductSelected || sourceProductCollection.length === 0}
                                                onClick={handleClickExportType}
                                                startIcon={<DownloadIcon />}
                                                endIcon={<KeyboardArrowDownSharp />}
                                            >
                                                Export
                                            </Button>
                                            <StyledMenu
                                                id="demo-customized-menu"
                                                MenuListProps={{
                                                    "aria-labelledby": "demo-customized-button",
                                                }}
                                                anchorEl={anchorEl2}
                                                open={openExportType}
                                                onClose={handleCloseExportType}
                                            >
                                                <MenuItem
                                                    disableRipple
                                                    onClick={() => openStockLedgerExportPopup("pdf")}
                                                >
                                                    PDF
                                                </MenuItem>
                                                <MenuItem
                                                    disableRipple
                                                    onClick={() => openStockLedgerExportPopup("Excel")}
                                                >
                                                    EXCEL
                                                </MenuItem>
                                            </StyledMenu>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Paper elevation={4} className="paper-container">
                                    {isProductSelected ? (
                                        <>
                                            {resultData?.stockLedgerListCollection?.length > 0 ? (
                                                resultData.stockLedgerListCollection.map(
                                                    (productData: any, index: number) => {
                                                        const isOpen = openProduct?.includes(productData?.productId);
                                                        const productDetails = resultData?.stockLedgerDetailCollection?.filter(
                                                            (x: any) => x.productId === productData?.productId
                                                        ) || [];

                                                        return (
                                                            <React.Fragment key={index}>
                                                                <List component="div" disablePadding>
                                                                    <ListItemButton
                                                                        sx={{
                                                                            borderTop:
                                                                                index !== 0
                                                                                    ? "1px solid #e9e9ef"
                                                                                    : "none",
                                                                            "&:hover": {
                                                                                backgroundColor: "#f1f6fe",
                                                                            },
                                                                            backgroundColor: isOpen
                                                                                ? "#f1f6fe"
                                                                                : "#fff",
                                                                        }}
                                                                        onClick={(e) => {
                                                                            e.preventDefault();
                                                                            handleClickProduct(productData?.productId);
                                                                        }}
                                                                    >
                                                                        {isOpen ? (
                                                                            <ExpandLess sx={{ mr: 1 }} />
                                                                        ) : (
                                                                            <ExpandMore sx={{ mr: 1 }} />
                                                                        )}
                                                                        <Box
                                                                            sx={{
                                                                                display: "flex",
                                                                                gap: 2,
                                                                                width: "100%",
                                                                                flexWrap: "wrap",
                                                                            }}
                                                                        >
                                                                            <Box
                                                                                display={"flex"}
                                                                                sx={{
                                                                                    width: !tabMatches ? "33%" : "100%",
                                                                                }}
                                                                            >
                                                                                <Typography sx={{ fontWeight: 700 }}>
                                                                                    {productData?.productName}
                                                                                </Typography>
                                                                            </Box>
                                                                        </Box>
                                                                    </ListItemButton>
                                                                    <Collapse
                                                                        in={isOpen}
                                                                        timeout="auto"
                                                                        unmountOnExit
                                                                    >
                                                                        <TableContainer>
                                                                            <Table aria-labelledby="tableTitle">
                                                                                <TableHead className="table-header-color">
                                                                                    <TableRow>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="left"
                                                                                        >
                                                                                            Voucher No
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Voucher Type
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Available Qty
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Inward Qty
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Outward Qty
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Closing Balance
                                                                                        </TableCell>
                                                                                        <TableCell
                                                                                            sx={{ fontWeight: "bold" }}
                                                                                            align="right"
                                                                                        >
                                                                                            Stock Value(₹)
                                                                                        </TableCell>
                                                                                    </TableRow>
                                                                                </TableHead>

                                                                                <TableBody>
                                                                                    {productDetails.length > 0 ? (
                                                                                        productDetails.map(
                                                                                            (
                                                                                                detailData: any,
                                                                                                detailIndex: number
                                                                                            ) => (
                                                                                                <TableRow
                                                                                                    key={detailIndex}
                                                                                                    sx={{
                                                                                                        "&:hover": {
                                                                                                            backgroundColor:
                                                                                                                "#f1f6fe",
                                                                                                            cursor: "pointer",
                                                                                                        },
                                                                                                    }}
                                                                                                >
                                                                                                    <TableCell align="left">
                                                                                                        {detailData?.voucherNo || '-'}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {detailData?.voucherType || '-'}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {numberFormat(
                                                                                                            Math.abs(detailData?.availableQuantity || 0),
                                                                                                            3,
                                                                                                            3
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {numberFormat(
                                                                                                            Math.abs(detailData?.inwardQty || 0),
                                                                                                            3,
                                                                                                            3
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {numberFormat(
                                                                                                            Math.abs(detailData?.outwardQty || 0),
                                                                                                            3,
                                                                                                            3
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {numberFormat(
                                                                                                            Math.abs(detailData?.closingBalance || 0),
                                                                                                            2,
                                                                                                            2
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                    <TableCell align="right">
                                                                                                        {numberFormat(
                                                                                                            Math.abs(detailData?.stockValue || 0),
                                                                                                            2,
                                                                                                            2
                                                                                                        )}
                                                                                                    </TableCell>
                                                                                                </TableRow>
                                                                                            )
                                                                                        )
                                                                                    ) : (
                                                                                        <TableRow>
                                                                                            <TableCell
                                                                                                colSpan={7}
                                                                                                align="center"
                                                                                            >
                                                                                                No record(s) found
                                                                                            </TableCell>
                                                                                        </TableRow>
                                                                                    )}
                                                                                </TableBody>
                                                                            </Table>
                                                                        </TableContainer>
                                                                    </Collapse>
                                                                </List>
                                                            </React.Fragment>
                                                        );
                                                    }
                                                )
                                            ) : (
                                                <Typography
                                                    sx={{
                                                        width: "100%",
                                                        display: "flex",
                                                        justifyContent: "center",
                                                        py: 3,
                                                    }}
                                                >
                                                    No record(s) found
                                                </Typography>
                                            )}

                                            {resultData?.stockLedgerListCollection?.length > 0 && (
                                                <Grid
                                                    container
                                                    paddingTop={1}
                                                    alignItems={"center"}
                                                    justifyContent={"center"}
                                                >
                                                    <Grid
                                                        item
                                                        xs={12}
                                                        sm={6}
                                                        className="pagination-label"
                                                    >
                                                        {pageStartIndex} - {pageEndIndex} of {totalCount}
                                                    </Grid>
                                                    <Grid item xs={12} sm={6}>
                                                        <Stack
                                                            component="div"
                                                            alignItems={mobileScreen ? "center" : "end"}
                                                            justifyContent={"center"}
                                                        >
                                                            <PaginationAdvance
                                                                page_Size={page_Size}
                                                                handlePageSizeCahange={(e) => {
                                                                    handlePageSizeCahange(e);
                                                                }}
                                                                counData={counData}
                                                                page_Index={page_Index}
                                                                handleChangePageIndex={handleChangePageNew}
                                                            />
                                                        </Stack>
                                                    </Grid>
                                                </Grid>
                                            )}
                                        </>
                                    ) : (
                                        <Typography
                                            sx={{
                                                width: "100%",
                                                display: "flex",
                                                justifyContent: "center",
                                                py: 4,
                                            }}
                                        >
                                            Product is Not Selected.
                                        </Typography>
                                    )}
                                </Paper>
                            </Paper>
                        </Grid>
                    </Grid>
                ) : (
                    <MissingConsumer consumerId={userContext.consumerId} />
                )}
            </Box>
        </>
    );
}